<dt-modal-content [size]="'big'" [contentPadding]="false" (closeClick)="close(false)">
  <ng-template #title i18n>Meinungen abgeben</ng-template>
  <ng-template #content>
    <mat-table [dataSource]="alternatives" matSort>
      <!-- User name Definition -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Alternative</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.name }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="opinion">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Meinung</mat-header-cell>
        <mat-cell *matCellDef="let row" class="opinion-cell">
          <button
            mat-icon-button
            class="opinion-button for"
            (click)="toggleOpinion(row.uuid, true)"
            [class.selected]="alternativeOpinions[row.uuid]?.sentiment === true"
            ><mat-icon>thumb_up</mat-icon></button
          >
          <button
            mat-icon-button
            class="opinion-button against"
            (click)="toggleOpinion(row.uuid, false)"
            [class.selected]="alternativeOpinions[row.uuid]?.sentiment === false"
            ><mat-icon>thumb_down</mat-icon></button
          >
          @if (alternativeOpinions[row.uuid] && alternativeOpinions[row.uuid].sentiment !== 'unset') {
            <mat-form-field subscriptSizing="dynamic">
              <input
                #commentInput
                matInput
                type="text"
                i18n-placeholder
                placeholder="Kommentar"
                [(ngModel)]="alternativeOpinions[row.uuid].comment"
              />
            </mat-form-field>
          }
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="['name', 'opinion']"></mat-header-row>
      <mat-row *matRowDef="let row; let index = index; columns: ['name', 'opinion']"></mat-row>
    </mat-table>
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button color="accent" (click)="close(true)" i18n>Übernehmen</button>
    <button mat-raised-button color="accent-less" (click)="close(false)" i18n>Verwerfen</button>
  </ng-template>
</dt-modal-content>
